export const CONSENT_STATUSES = {
  ASK_CONSENT: 0,
  AGREE: 1,
  REMIND: 2,
};
